// src/features/data-cleaning/dataCleaningSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeStep: 0,
    uploadedFiles: [],
    uploadedFileRes: [],
    uploadedUrls: [],
    loading: false,
    cleaningReport: null,
    analysisLoading: false,
    analysisDone: false,
    finalReportUrl: null,
    uiStep: 1,
    dataCleaningExcelSheets: {},
    dataCleaningSelectedSheets: {},
};

export const dataCleaningSlice = createSlice({
    name: "dataCleaning",
    initialState,
    reducers: {
        setUiStep: (state, action) => {
            state.uiStep = action.payload;
        },
        resetUiStep: (state) => {
            state.uiStep = 1;
        },
        setActiveStep: (state, action) => {
            state.activeStep = action.payload;
        },
        nextStep: (state) => {
            state.activeStep += 1;
        },
        previousStep: (state) => {
            state.activeStep -= 1;
        },
        resetStep: (state) => {
            state.activeStep = 0;
        },
        addUploadedFiles: (state, action) => {
            state.uploadedFiles = [
                ...state.uploadedFiles,
                ...action.payload.map((file) => ({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                })),
            ];
        },
        addUploadedFileRes: (state, action) => {
            state.uploadedFileRes = [...state.uploadedFileRes, ...action.payload];
        },
        removeUploadedFile: (state, action) => {
            const index = action.payload;
            const fileToRemove = state.uploadedFiles[index];
            state.uploadedFiles = state.uploadedFiles.filter((_, i) => i !== index);
            state.uploadedUrls = state.uploadedUrls.filter((_, i) => i !== index);
            state.uploadedFileRes = state.uploadedFileRes.filter(
                (res) => !res.includes(fileToRemove.name)
            );
        },
        clearCleanedData: (state) => {
            state.uploadedFiles = [];
            state.uploadedFileRes = [];
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setCleaningReport: (state, action) => {
            state.cleaningReport = action.payload;
        },
        clearCleaningReport: (state) => {
            state.cleaningReport = initialState.cleaningReport;
        },
        setAnalysisLoading: (state, action) => {
            state.analysisLoading = action.payload;
        },
        setAnalysisDone: (state, action) => {
            state.analysisDone = action.payload;
        },
        setFinalReportUrl: (state, action) => {
            state.finalReportUrl = action.payload;
        },
        setUploadedUrls: (state, action) => {
            state.uploadedUrls = [...state.uploadedUrls, ...action.payload];
        },
        addUploadedUrl: (state, action) => {
            state.uploadedUrls.push(action.payload);
        },
        setDataCleaningExcelSheets: (state, action) => {
            state.dataCleaningExcelSheets = { ...state.dataCleaningExcelSheets, ...action.payload };
        },
        setDataCleaningSelectedSheets: (state, action) => {
            state.dataCleaningSelectedSheets = action.payload;
        },
        resetCleaning: (state) => {
            const newState = { ...initialState };
            return newState;
        },
    },
});

export const {
    setActiveStep,
    nextStep,
    previousStep,
    resetStep,
    addUploadedFiles,
    addUploadedFileRes,
    removeUploadedFile,
    clearCleanedData,
    setLoading,
    setCleaningReport,
    resetCleaning,
    clearCleaningReport,
    setAnalysisLoading,
    setAnalysisDone,
    setUiStep,
    resetUiStep,
    setUploadedUrls,
    addUploadedUrl,
    resetUploadedUrls,
    setFinalReportUrl,
    setDataCleaningExcelSheets,
    setDataCleaningSelectedSheets,
} = dataCleaningSlice.actions;

export default dataCleaningSlice.reducer;